import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";

/** A thin crimson bar at the very top that fills as the story is read. */
export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max =
        document.documentElement.scrollHeight - window.innerHeight || 1;
      setProgress(Math.min(Math.max(window.scrollY / max, 0), 1) * 100);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      h="3px"
      w={`${progress}%`}
      zIndex="1500"
      bgGradient="linear(to-r, #60A5FA, #93C5FD)"
      boxShadow="0 0 12px #60A5FA"
      transition="width 0.1s linear"
    />
  );
}
